import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { filter, take } from 'rxjs';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { CommunityProductPagination } from 'src/app/shareModule/models/community-product.model';
import { User } from 'src/app/shareModule/models/user.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-individual-services',
  templateUrl: './individual-services.component.html',
  styleUrls: ['./individual-services.component.scss'],
})
export class IndividualServicesComponent implements OnInit {
  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;

  public rolesCount = [

  ]

  public allProductsCount = 0

  public get areAllSelected() {
    return this.rolesCount.every(cat => cat.selected)
  }
  public selectAll() {
    if (this.areAllSelected) {
      this.rolesCount.forEach(cat => cat.selected = false);
      this.selectedSubCats = []

      return
    }
    this.rolesCount.forEach(cat => cat.selected = true);
    this.selectedSubCats = Array.from(new Set(this.rolesCount.map(i => i.id)))

    this._getMemberShopProduct();

  }

  public selectedMemberRegion: string = '';
  carouselOptions: any = {
    nav: true,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    margin: 10,
    autoWidth: true,
  };
  allProduct: CommunityProductPagination = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0
  };
  allProductByRegion: any = [];
  adsList: any;
  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  width: any = 0;
  user: any = null;
  // noDonations: boolean = false;
  // noRental: boolean = false;
  latLong: any = {};
  loading: boolean = false;
  isLoadingAllProductMore: boolean = false;
  search: string = ''
  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private customerService: CustomerService,
    private sharedService: SharedService,
    private memberNotificationService: MemberNotificationService,
    public roleService: RoleService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    @Inject("WINDOW") private window: any,
  ) { }
  ngOnInit(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;

      }
    });
    this.loading = true;
    this.width = this.window.innerWidth;
    this.auth.getCountsOfRolesInUsersSubRegion(this.user.region).subscribe(
      {
        next: (data: any) => {
          data.data.sort(x => -1 * x.serviceCounts)
          // this.rolesCount = data.data.filter(cat => cat.recommendationCounts && cat.name?.trim());
          this.rolesCount = data.data;
          this.rolesCount.forEach(cat => cat.selected = true)
          this.selectedSubCats = Array.from(this.rolesCount.map(i => i.id))


          this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
            if (r?.regionName) {
              this.selectedMemberRegion = r.regionName;


              this.getAds('', this.selectedMemberRegion);
            } else {

              this.loading = false
            }
            this._getMemberShopProduct();
          });




        },
        error: err => {
          console.error(err);
          this.toastr.error("Something went wrong while fetching role count")
        }
      }
    )

    this.local.getUserDetailsObserver().subscribe(async (user) => {
      if (user?.id) {
        this.isLogin = 1;
        this.latLong = user.latLong
      } else {
        this.isLogin = 0;
      }
    });


  }
  openShopPopup(name) {
    this.sharedService.triggerInitTabProfile('shop');
    setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(name);
    }, 100);
  }


  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }
  public getAds(category: string, memberShopSubRegion: string): void {
    this.auth
      .getMemberShopAdsBy(category, memberShopSubRegion)
      .subscribe((resp: ApiResponse) => {
        this.adsList = resp.body;
      });
  }
  public clearFilters() {
    this.rolesCount.forEach(role => role.selected = false);
    this.selectedSubCats = []
    this._getMemberShopProduct();
  }
  public selectRole(role) {
    role.selected = !role.selected;
    if (role.selected) {
      this.selectedSubCats.push(role.id)
    } else {
      this.selectedSubCats.splice(this.selectedSubCats.indexOf(role.id), 1)

    }
    this._getMemberShopProduct();
  }

  public selectedSubCats = []

  public _getMemberShopProduct(page: number = 1) {
    this.customerService
      .getMemberShopProductList({
        categoryId: this.selectedSubCats.length ? this.selectedSubCats : Array.from(this.rolesCount.map(role => role.id)),
        search: this.search,
        subRegionId: (this.user.region ? [Number(this.user.region)] : []),
        basedProduct: 'shop_promote',
        page: page
      })
      .subscribe((response: any) => {
        response = response.body

        if (response.currentPage === 1) this.allProduct.data = []
        if (response?.data)
          this.allProduct = {
            ...response,
            data: [
              ...this.allProduct.data,
              ...response?.data
            ]
          };
        // this.local.checkDistanceProducts(this.allProduct, this.latLong);
        // this.local.sortByNearestAndHigherPoints(this.allProduct);
        this.loading = false
        this.isLoadingAllProductMore = false
      }
      );

  }

  public viewProductDetails(product): void {
    this.marketplaceProfileSection.enableMemberShop = true;
    this.marketplaceProfileSection.viewProduct(product);
  }

  handleSearch(event: any): void {
    this.search = event.target.value;
    this._getMemberShopProduct();
  }
}
